import React, { useState } from 'react'
import { Tab } from '@headlessui/react'
import LazyLoad from 'react-lazyload';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Timeline() {

  let [week1] = useState({
    'Mon (3rd)': [
      {
        id: 29,
        title: 'Mathematical Logic',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Sunil Simon',
        image: 'iitk-logo.png'
      },
    {
        id: 2,
        title: 'Mathematical Logic',
        time: '11:00 - 12:30 pm',
        speaker: 'Prof. Sunil Simon',
        image: 'iitk-logo.png'
    },
      {
        id: 3,
        title: 'Industry Perspective on Compilers',
        time: '2:00 - 3:30 pm',
        speaker: 'Sushim Srivastava',
        image: 'qcom.png'
      },
    {
        id: 4,
        title: 'Hands-on Session : Z3, PySat & Z3Py',
        time: '4:00 - 5:30 pm',
        speaker: 'Priyanka, Gourav',
        image: 'iitk-logo.png'
    },
    ],
     'Tues (4th)': [
     {
        id: 1,
        title: 'Processor datapath/pipelining, branch prediction, dynamic instrn. scheduling (basics)',
        time: '8:30 - 10:00 am',
        speaker: 'Prof. R. Govindarajan',
         image: 'iisc-logo.png'

      },
      {
        id: 2,
        title: 'Cache architecture, multi-level caches, TLB/address translation, virtual caches',
        time: '10:30 - 12:00 noon',
        speaker: 'Prof. R. Govindarajan',
          image: 'iisc-logo.png'

      },
      {
        id: 3,
        title: 'ILP processors (superscalar)',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Madhu Mutyam',
          image: 'iitm-logo.png'
      },
         {
             id: 4,
             title: 'Hands-on Session : Intel PIN/Cache',
             time: '4:00 - 5:30 pm',
             speaker: 'Prantik, Sumit',
             image: 'iitk-logo.png'
         }
    ],
      'Wed (5th)': [
      {
          id: 1,
          title: 'Multiprocessor/Multicore architecture, Multi-core caches, Cache Coherence',
          time: '10:30 - 12:00 noon',
          speaker: 'Prof. R. Govindarajan',
          image: 'iisc-logo.png'
      },
      {
        id: 2,
        title: 'ILP processors (superscalar)',
        time: '8:30 - 10:00 am',
        speaker: 'Prof. Madhu Mutyam',
         image: 'iitm-logo.png'
      },
      {
        id: 3,
        title: 'Memory consistency(intro.) and DRAM',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Madhu Mutyam',
          image: 'iitm-logo.png'
      },
     {
         id: 4,
         title: 'Hands-on Session : Intel PIN/Cache',
         time: '4:00 - 5:30 pm',
         speaker: 'Prantik, Sumit',
         image: 'iitk-logo.png'
     }
    ],
      'Thurs (6th)': [
     {
        id: 1,
        title: 'Reactive Synthesis',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Supratik Chakraborty',
         image: 'iitb-logo.png'
      },
      {
        id: 2,
        title: 'Reactive Synthesis',
        time: '11:00 - 12:30 pm',
        speaker: 'Prof. Supratik Chakraborty',
          image: 'iitb-logo.png'
      },
      {
        id: 3,
        title: 'Reactive Synthesis',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Supratik Chakraborty',
          image: 'iitb-logo.png'
      },
        {
            id: 4,
            title: 'Hands-on Session : Strix Tool (Reactive Systems)',
            time: '4:00 - 5:30 pm',
            speaker: 'Sujit, Pankaj',
            image: 'iitk-logo.png'
        }
    ],
      'Fri (7th)': [
     {
        id: 1,
        title: 'Hardware Verification',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Supratik Chakraborty',
         image: 'iitb-logo.png'
      },
      {
        id: 2,
        title: 'Hardware Verification',
        time: '11:00 - 12:30 pm',
        speaker: 'Prof. Supratik Chakraborty',
          image: 'iitb-logo.png'
      },
      {
        id: 3,
        title: 'Hardware Verification',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Supratik Chakraborty',
          image: 'iitb-logo.png'
      },
        {
            id: 4,
            title: 'Hands-on Session : ABC Tool (HW Verification)',
            time: '4:00 - 5:30 pm',
            speaker: 'Priyanka, Gourav',
            image: 'iitk-logo.png'
        }
    ],
  })

   let [week2] = useState({
       'Mon (10th)': [
      {
        id: 1,
        title: 'Execution Environments',
        time: '9:00 - 10:30 am',
        speaker: 'Dr. Abhijat Vichare',
          image: 'acm.png'
      },
      {
        id: 2,
        title: 'Execution Environments',
        time: '11:00 - 12:30 pm',
        speaker: 'Dr. Abhijat Vichare',
          image: 'acm.png'
      },
      {
        id: 3,
        title: 'Hexagon Architecture',
        time: '2:00 - 3:30 pm',
        speaker: 'Abhikrant Sharma',
          image: 'qcom.png'
      },
        {
            id: 4,
            title: 'Hands-on Session : Linker & Loaders',
            time: '4:00 - 5:30 pm',
            speaker: 'Yash, Awanish/Sumit',
            image: 'iitk-logo.png'
        }
    ],
       'Tues (11th)': [
     {
        id: 1,
        title: 'Compilers',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Amey Karkare',
         image: 'iitk-logo.png'
      },
      {
        id: 2,
        title: 'Compilers',
        time: '11:00 - 12:30 pm',
        speaker: 'Prof. Y. N. Srikant',
          image: 'iisc-logo.png'
      },
      {
        id: 3,
        title: 'Compilers',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Y. N. Srikant',
          image: 'iisc-logo.png'
      },
         {
             id: 4,
             title: 'Hands-on Session : LLVM & Clang',
             time: '4:00 - 5:30 pm',
             speaker: 'Nitesh, Sumit',
             image: 'iitk-logo.png'
         }
    ],
       'Wed (12th)': [
      {
        id: 1,
        title: 'Compilers',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Amey Karkare',
          image: 'iitk-logo.png'
      },
      {
        id: 2,
        title: 'Compilers',
        time: '11:00 - 12:30 pm',
          speaker: 'Prof. Y. N. Srikant',
          image: 'iisc-logo.png'
      },
      {
        id: 3,
        title: 'Compilers',
        time: '2:00 - 3:30 pm',
          speaker: 'Prof. Amey Karkare',
          image: 'iitk-logo.png'
      },
         {
             id: 4,
             title: 'Hands-on Session : LLVM & Clang',
             time: '4:00 - 5:30 pm',
             speaker: 'Nitesh, Sumit',
             image: 'iitk-logo.png'
         }
    ],
       'Thurs (13th)': [
      {
        id: 1,
        title: 'Software Testing and Verification',
        time: '9:00 - 10:30 am',
        speaker: 'Prof. Subhajit Roy',
          image: 'iitk-logo.png'
      },
      {
        id: 2,
        title: 'Software Testing and Verification',
        time: '11:00 - 12:30 pm',
        speaker: 'Prof. Subhajit Roy',
          image: 'iitk-logo.png'
      },
      {
        id: 3,
        title: 'Software Testing and Verification',
        time: '2:00 - 3:30 pm',
        speaker: 'Prof. Subhajit Roy',
          image: 'iitk-logo.png'
      },
        {
            id: 4,
            title: 'Hands-on Session : KLEE & Z3',
            time: '4:00 - 5:30 pm',
            speaker: 'Pankaj, Sujit',
            image: 'iitk-logo.png'
        }
    ],
       'Fri (14th)': [
      {
        id: 1,
        title: 'Hexagon SDK',
        time: '9:00 - 10:30 am',
        speaker: 'Maitreyi Gupta, Atul Pant',
          image: 'qcom.png'
      },
      {
        id: 2,
        title: 'Halide',
        time: '11:00 - 12:30 pm',
        speaker: 'Suyog Sarda',
          image: 'qcom.png'
      },
        {
            id: 3,
            title: 'Hands-on : Hexagon SDK',
            time: '2:00 - 3:30 pm',
            speaker: 'Maitreyi, Atul, Seshu',
            image: 'qcom.png'
        },
        {
            id: 4,
            title: 'Hands-on : Hexagon SDK',
            time: '4:00 - 5:30 pm',
            speaker: 'Maitreyi, Atul, Seshu',
            image: 'qcom.png'
        }
    ]
  })

    const tools = [
        {
            name: 'PySat',
            url: 'https://pysathq.github.io/',
            image: 'pysat.png'
        },
        {
            name: 'Z3 SMT Solver',
            url: 'https://github.com/Z3Prover/z3',
            image: 'z3.jpeg'
        },
        {
            name: 'PyZ3 (Z3 Python)',
            url: 'https://ericpony.github.io/z3py-tutorial/guide-examples.htm',
            image: 'python3.png'
        },
        {
            name: 'LLVM',
            url: 'https://llvm.org/docs/GettingStarted.html',
            image: 'llvm.png'
        },
        {
            name: 'GCC',
            url: 'https://gcc.gnu.org/',
            image: 'gcc.svg'
        },
        {
            name: 'Clang',
            url: 'https://clang.llvm.org/',
            image: 'llvm.png'
        },
        {
            name: 'Mingw (Windows)',
            url: 'https://www.mingw-w64.org/',
            image: 'mingw.svg'
        },
        {
            name: 'Intel PIN',
            url: 'https://www.intel.com/content/www/us/en/developer/articles/tool/pin-a-dynamic-binary-instrumentation-tool.html',
            image: 'intel.png'
        },
        {
            name: 'Strix (Reactive)',
            url: 'https://strix.model.in.tum.de/',
            image: 'terminal.png'
        },
        {
            name: 'KLEE (SymbEx)',
            url: 'https://klee.github.io/',
            image: 'klee.svg'
        },
        {
            name: 'ABC Tool',
            url: 'http://people.eecs.berkeley.edu/~alanmi/abc/',
            image: 'terminal.png'
        },
        {
            name: 'Angr Tool',
            url: ' https://angr.io/',
            image: 'angr.png'
        },
        {
            name: 'CMake Tool',
            url: ' https://cmake.org/',
            image: 'cmake.jpeg'
        },
        {
            name: 'PCM Tool',
            url: ' https://github.com/opcm/pcm',
            image: 'github.png'
        },
        {
            name: 'Hexagon SDK (Win)',
            url: ' https://developer.qualcomm.com/',
            image: 'qcom.png'
        },
    ]

    const slides = [
        {
            name: 'Multicore Processors (Week-1)',
            url: 'multicore.pptx',
            image: 'rgovind.jpg'
        },
        {
            name: 'Cache Hierarchies (Week-1)',
            url: 'caches.pptx',
            image: 'rgovind.jpg'
        },
        {
            name: 'Processor Pipeline (Week-1)',
            url: 'pipeline.pptx',
            image: 'rgovind.jpg'
        },
        {
            name: 'DRAM Memory (Week-1)',
            url: 'DRAMMemoryOrganization.pdf',
            image: 'madhumutyam.jpg'
        },
        {
            name: 'Memory Consistencies (Week-1)',
            url: 'MemoryConsistency.pdf',
            image: 'madhumutyam.jpg'
        },
        {
            name: 'Superscalar Processors  (Week-1)',
            url: 'SuperscalarProcessor.pdf',
            image: 'madhumutyam.jpg'
        },
        {
            name: 'Mathematical Logic  (Week-1)',
            url: 'Logic.pdf',
            image: 'sunilsimon.jpg'
        },
        {
            name: 'Runtime Environments-1  (Week-2)',
            url: 'runtime-environments-1.pdf',
            image: 'abhijatvichare.jpg'
        },
        {
            name: 'Runtime Environments-2  (Week-2)',
            url: 'runtime-environments-2.pdf',
            image: 'abhijatvichare.jpg'
        },
        {
            name: 'Data Flow/Control Flow Analysis',
            url: 'dfa_cfa.pdf',
            image: 'srikant.jpg'
        },
        {
            name: 'Optimizations (Compilers)',
            url: 'Local and Global Optimizations.pdf',
            image: 'srikant.jpg'
        },
        {
            name: 'SSA Form (IR)',
            url: 'SSA.pdf',
            image: 'srikant.jpg'
        },
        {
            name: 'Target Codegen (Compilers)',
            url: '02A_CodeGen.pdf',
            image: 'amey.jpg'
        },
        {
            name: 'Type System (Compilers)',
            url: '01A_TypesAndPLSlides.pdf',
            image: 'amey.jpg'
        },
        {
            name: 'Hexagon SDK (Slides)',
            url: 'HexagonSDK_presentation.pdf',
            image: 'atul.jpeg'
        },
        {
            name: 'Hallide (Slides)',
            url: 'hallide.pptx',
            image: 'suyog.jpg'
        },
    ]

    return (
      <div>
 <section className="relative" data-aos="zoom-y-out" id="timeline">

      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div className="absolute inset-0 top-1/2 md:mt-24 lg:mt-0 bg-white pointer-events-none" aria-hidden="true"></div>
      <div className="absolute left-0 right-0 bottom-0 m-auto w-px p-px h-20 bg-300-200 transform translate-y-1/2"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
          <br />
          <br />
          <h5 className="text-xl md:text-2xl font-extrabold leading-tighter tracking-tighter mb-4"
              data-aos="zoom-y-out">Tools & Frameworks</h5>
          <h5 className="text-xl text-gray-800">
              Although not exhaustive, we will be using the following tools for demonstrations during the hands-on sessions. You may be asked to install and
              run these tools for completing the related assignments. More information on these tools will be shared in the respective hands-on sessions. Please make
              sure you have a linux/Windows system ready for the hands-on session.
          </h5>
          <div className="mt-10" data-aos="zoom-y-out" data-aos-delay="150">
              <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-3">
                  {tools.map((feature) => (
                      <div key={feature.name} className="flex flex-row justify-start px-4
                      card cursor-pointer rounded-full hover:bg-gray-100
                       hover:text-green-700 shadow-lg item-center text-center ring ring-2
                       ring-offset-2 ring-sky-200 ring-offset-sky-400"
                       onClick={(e) => {
                          e.preventDefault();
                          window.location.href = feature.url
                      }}>
                          <div className="m-1 flex flex-row text-left w-max">
                              <LazyLoad height={8}>
                                <img alt="feature" className="mx-auto w-8 h-8"
                                     src={require(`../images/${feature.image}`).default} />
                              </LazyLoad>
                              <span className="px-2 py-1 inline rounded-lg
                    font-bold text-lg flex items-center cursor-pointer">{feature.name}
                    </span>
                          </div>
                      </div>
                  ))}
              </div>
          </div>
        <div className="py-12 md:py-20">
            {/* Start */}
            <div className="w-full h-full">
                <Tab.Group onChange={(e) => {
                    const elem = document.getElementById('bottom')
                    setImmediate(() => {
                        elem.scrollIntoView({behavior: 'smooth'});
                    })
                }}>
                    <Tab.List className="flex flex-row bg-blue-900/20 rounded-xl h-24">
                        <div className="w-10 md:w-52"></div>
                        <Tab className={({selected}) => classNames( selected ? 'text-gray-900 focus:outline-none' : 'text-gray-300')}>
                            <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20 font-bold bg-white
                            rounded-lg transition duration-300 ease-in-out relative py-6">
                                <h2 className="h2" onClick={(e) => {
                                    e.preventDefault();
                                    const elem = document.getElementById('bottom')
                                    setImmediate(() => {
                                        elem.scrollIntoView({behavior: 'smooth'});
                                    })
                                }}>Week-1</h2>
                            </div>
                        </Tab>
                        <div className="w-10 md:w-52"></div>
                        <div className="w-0 md:w-44"></div>
                        <Tab className={({selected}) => classNames( selected ? 'text-gray-900 focus:outline-none' : 'text-gray-300')}>
                            <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20 font-bold bg-white
                            outline-none rounded-lg transition duration-300 ease-in-out relative py-6">
                                <h2 className="h2" onClick={(e) => {
                                    e.preventDefault();
                                    const elem = document.getElementById('bottom')
                                    setImmediate(() => {
                                        elem.scrollIntoView({behavior: 'smooth'});
                                    })
                                }}>Week-2</h2>
                            </div>
                            <div id="bottom"></div>
                        </Tab>
                    </Tab.List>
                    <Tab.Panel className="w-full h-full">
                        <Tab.Group>
                            <Tab.List className="flex space-x-1 bg-blue-900/20 rounded-xl">
                                {Object.keys(week1).map((category) => (
                                    <Tab
                                        key={category}
                                        className={({ selected }) =>
                                            classNames(
                                                'w-full py-2 px-1 font-bold bg-white hover:shadow-xl rounded-lg transition duration-300 ease-in-out relative',
                                                'focus:outline-none',
                                                selected
                                                    ? 'shadow-xl ring-2 ring-offset-2 ring-offset-blue-800 ring-blue-200'
                                                    : 'text-blue-700 hover:text-yellow'
                                            )
                                        }
                                    >
                                        {category}
                                    </Tab>
                                ))}
                            </Tab.List>
                            <div className="w-full bg-white">
                                <div className="relative wrap overflow-hidden p-10 h-full">
                                    {Object.values(week1).map((posts, idx) => (                                       <Tab.Panel
                                            key={idx}
                                            className={classNames(
                                                'bg-white rounded-xl',
                                                'focus:outline-none'
                                            )}
                                        >
                                            <div className='grid grid-cols-1 md:grid-cols-12 gap-2'>
                                                {posts[0].id !== 29 && <div className="md:col-start-1 md:col-end-7 text-left transition duration-500 ease-in-out w-full
                                                relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[0].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[0].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[0].title}</p>
                                                        {
                                                            posts[0].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                                        font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                      <LazyLoad height={7}><img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                                            src={require(`../images/${posts[0].image}`).default}/>
                                                      </LazyLoad>
                                                            <span className="flex items-center px-2 py-1">
                                                              {posts[0].speaker}
                                                            </span>
                                                        </span>
                                                        }
                                                    </div>
                                                </div>}
                                                {posts[0].id === 29 &&
                                                    <div
                                                        className="justify-center items-center text-left md:col-start-1 md:col-end-3 text-center transition duration-500 ease-in-out w-full relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-green-300 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                        <div className="flex flex-col py-6">
                                                            <p className="text-xl font-bold leading-snug">Introduction to Winter School</p>
                                                            <p className="text-xs font-bold leading-snug">(8:30-9:00 am)</p>
                                                        </div>
                                                    </div>}
                                                {posts[0].id === 29 &&
                                                    <div className="md:col-start-3 md:col-end-7 text-left transition duration-500 ease-in-out w-full
                                                relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                        <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                            <div className="flex justify-between item-center">
                                                                <p className="text-xl font-bold leading-snug">Session-1</p>
                                                                <div
                                                                    className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                    {posts[0].time}</div>
                                                            </div>
                                                            <p className="md:text-lg font-bold text-gray-500 text-base">{posts[0].title}</p>
                                                            {
                                                                posts[0].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                                        font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                                            <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                                                 src={require(`../images/${posts[0].image}`).default}/>
                                                            </LazyLoad>
                                                            <span className="flex items-center px-2 py-1">
                                                              {posts[0].speaker}
                                                            </span>
                                                        </span>
                                                            }
                                                        </div>
                                                    </div>}
                                                {/**/}
                                                <div
                                                    className="md:col-start-7 md:col-end-8 text-center transition duration-500 ease-in-out w-full relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-yellow-200 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="flex flex-col py-6">
                                                        <p className="text-xl font-bold leading-snug">Break</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-8 md:col-end-13 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[1].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[1].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[1].title}</p>
                                                        {
                                                            posts[1].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                    <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[1].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[1].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                                {/* Lunch */}
                                                <div
                                                    className="md:col-start-1 md:col-end-13 text-center transition duration-500 ease-in-out w-full h-10 relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-gray-900 w-10 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full flex flex-col py-1 ">
                                                        <p className="text-xl font-bold text-white leading-snug">Lunch (12:30-2:00 pm)</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-1 md:col-end-7 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[2].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[2].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[2].title}</p>
                                                        {
                                                            posts[2].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[2].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[2].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-7 md:col-end-8 text-center transition duration-500 ease-in-out w-full relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-yellow-200 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="flex flex-col py-6">
                                                        <p className="text-xl font-bold leading-snug">Break</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-8 md:col-end-13 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[3].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[3].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[3].title}</p>
                                                        {
                                                            posts[3].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[3].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[3].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </Tab.Panel>
                                    ))}
                                </div>
                            </div>
                        </Tab.Group>
                    </Tab.Panel>
                    <Tab.Panel className="w-full h-full">
                        <Tab.Group>
                            <Tab.List className="flex space-x-1 bg-blue-900/20 rounded-xl">
                                {Object.keys(week2).map((category) => (
                                    <Tab
                                        key={category}
                                        className={({ selected }) =>
                                            classNames(
                                                'w-full py-2 px-1 font-bold bg-white hover:shadow-xl rounded-lg transition duration-300 ease-in-out relative',
                                                'focus:outline-none',
                                                selected
                                                    ? 'shadow-xl ring-2 ring-offset-2 ring-offset-blue-800 ring-blue-200'
                                                    : 'text-blue-700 hover:text-yellow'
                                            )
                                        }
                                    >
                                        {category}
                                    </Tab>
                                ))}
                            </Tab.List>
                            <div className="w-full bg-white">
                                <div className="relative wrap overflow-hidden p-10 h-full">
                                    {Object.values(week2).map((posts, idx) => (
                                        <Tab.Panel
                                            key={idx}
                                            className={classNames(
                                                'bg-white rounded-xl',
                                                'focus:outline-none'
                                            )}
                                        >
                                            <div className='grid grid-cols-1 md:grid-cols-12 gap-2'>
                                                <div
                                                    className="md:col-start-1 md:col-end-7 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[0].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[0].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[0].title}</p>
                                                        {
                                                            posts[0].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[0].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[0].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-7 md:col-end-8 text-center transition duration-500 ease-in-out w-full relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-yellow-200 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="flex flex-col py-6">
                                                        <p className="text-xl font-bold leading-snug">Break</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-8 md:col-end-13 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[1].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[1].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[1].title}</p>
                                                        {
                                                            posts[1].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[1].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[1].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                                {/* Lunch */}
                                                <div
                                                    className="md:col-start-1 md:col-end-13 text-center transition duration-500 ease-in-out w-full h-10 relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-gray-900 w-10 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full flex flex-col py-1 ">
                                                        <p className="text-xl font-bold text-white leading-snug">Lunch (12:30-2:00 pm)</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-1 md:col-end-7 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[2].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[2].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[2].title}</p>
                                                        {
                                                            posts[2].speaker !== "" && <span className="rounded-full shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[2].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[2].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-7 md:col-end-8 text-center transition duration-500 ease-in-out w-full relative flex flex-col
                                                    rounded shadow-xl hover:shadow-lg hover:border-gray-200 border
                        border-white bg-yellow-200 ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="flex flex-col py-6">
                                                        <p className="text-xl font-bold leading-snug">Break</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="md:col-start-8 md:col-end-13 text-left transition duration-500 ease-in-out w-full relative flex flex-col md:flex-row md:space-x-5 space-y-3
                        md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto border
                        border-white bg-white ring-4 ring-offset-2 ring-offset-gray-900 ring-gray-300 cursor-pointer">
                                                    <div className="w-full bg-white flex flex-col space-y-2 p-3">

                                                        <div className="flex justify-between item-center">
                                                            <p className="text-xl font-bold leading-snug">Session-{posts[3].id}</p>
                                                            <div
                                                                className="bg-sky-300 px-2 py-1 rounded-full subpixel-antialiased text-xs font-bold text-black shadow-xl">
                                                                {posts[3].time}</div>
                                                        </div>
                                                        <p className="md:text-lg font-bold text-gray-500 text-base">{posts[3].title}</p>
                                                        {
                                                            posts[3].speaker !== "" && <span className="rounded-full
                                                            shadow-xl bg-blue-700 text-white
                                font-bold text-xs flex align-center cursor-pointer transition duration-300 ease w-max">
                                                            <LazyLoad height={7}>
                                    <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                         src={require(`../images/${posts[3].image}`).default}/></LazyLoad>
                                    <span className="flex items-center px-2 py-1">
                                      {posts[3].speaker}
                                    </span>
                                </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Panel>
                                    ))}
                                </div>
                            </div>
                        </Tab.Group>
                    </Tab.Panel>
                </Tab.Group>
            </div>
            <br />
            <h5 className="text-2xl text-gray-800">
                Slides and References for download.
            </h5>
            <div className="mt-10">
                <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    {slides.map((feature) => (
                        <a key={feature.name} download className="card cursor-pointer rounded-lg
                        bg-gradient-to-r from-blue-50 to-white bg-gray-200 hover:bg-gray-500
                       hover:text-blue-900 shadow-sm ring ring-2 ring-offset-2 ring-sky-200 ring-offset-blue-500" href={`../slides/${feature.url}`}>
                            <div className="flex justify-between text-left item-center">
                                <LazyLoad height={8}>
                                    <img alt="feature" className="mx-auto w-9 h-9 px-1 py-1"
                                         src={require(`../images/${feature.image}`).default} />
                                </LazyLoad>
                                <span className="px-2 py-1 inline rounded-lg
                    font-mono font-bold text-sm flex items-center cursor-pointer">{feature.name}
                                </span>
                                <div className="text-sm font-mono inline rounded-full px-2 py-1 float-left animate-pulse">
                                        <span className="material-icons-two-tone justify-items-end">
                                            <img src={require(`../images/down.svg`).default}/>
                                        </span>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
            {/* End */}
        </div>
      </div>
    </section>
    </div>
  )
}
